import { z } from "zod";
export const BlogPostSchema = z.object({
    title: z.string().min(1),
    url: z.url(),
    publishedAt: z.iso.date(),
    imageUrl: z.url().nullable(),
});
export const BlogPostsSchema = z.array(BlogPostSchema);
